
// Autentyczne dane ChKŻ LOK - źródło: Facebook i Instagram
// https://www.facebook.com/ChodzieskiKlubZeglarskiLOK
// https://www.instagram.com/chkz.lok_/

export const clubInfo = {
  name: 'Chodzieski Klub Żeglarski LOK',
  shortName: 'ChKŻ LOK',
  tagline: 'Żeglarstwo — sztuka o randze życia i życie o randze sztuki',
  taglineEmoji: '🤙🏽⛟️💨',
  location: 'Chodzież, Polska',
  coordinates: '52.989459, 16.924349',
  email: 'chkzlok@gmail.com',
  category: 'Klub sportowy',
  rating: '90% poleca (15 opinii)',
  facebookFollowers: 812,
  instagramFollowers: 62,
  instagramFollows: 28,
  instagramPosts: 36,
  facebookUrl: 'https://www.facebook.com/ChodzieskiKlubZeglarskiLOK',
  instagramUrl: 'https://www.instagram.com/chkz.lok_/',
};

export const clubImages = {
  hero: '/images/3.jpg',
  lake: '/images/2_1200x1500.webp',
  training: '/images/1_1200x1200.webp',
  heroBg: '/images/1.webp',
  lakeBg: '/images/2.webp',
};

export interface Comment {
  user: string;
  text: string;
}

export interface NewsPost {
  id: string;
  dateFull: string;
  caption: string;
  image: string;
  likes: number;
  comments: number;
  commentsList?: Comment[];
}

export interface Activity {
  title: string;
  description: string;
  icon: string;
}

export interface Regatta {
  title: string;
  date: string;
  location: string;
  description: string;
  image: string;
  likes: number;
  comments: number;
}

export interface GalleryItem {
  src: string;
  alt: string;
  caption: string;
}

export const newsPosts: NewsPost[] = [
  {
    id: 'post0',
    dateFull: '10 sierpnia 2026',
    caption: '⛣️🌊 W dniach 7–9 sierpnia odbył się nasz piknik żeglarski! Trzy dni pełne żeglowania, wspólnej zabawy i świetnej atmosfery. Zaczęliśmy od treningu na żaglach i rozstawienia namiotów, a wieczorem obejrzeliśmy film „Wind”. Kolejny dzień przyniósł turniej badmintona, różne konkurencje i aktywności, a wieczorem wspólne śpiewanie szant przy ognisku. 🎶🔥Ostatni dzień rozpoczęliśmy od wyprawy kajakami i SUP-ami na Łazinkach. Po powrocie i złożeniu biwaku czekała na nas prawdziwie żeglarska pogoda — dużo wiatru i słońca! ☀️🌬️ Wspólnie z rodzicami i członkami klubu zeszliśmy na wodę, gdzie jednocześnie pływały łódki aż z siedmiu klas! ⛣️ Był to idealny sposób na zakończenie naszego piknic. Po powrocie na brzeg czekał na nas grill, którym zakończyliśmy te wyjątkowe trzy dni. 💙 Dziękujemy wszystkim za wspólnie spędzony czas i wspaniałą atmosferę🩵',
    image: clubImages.hero,
    likes: 23,
    comments: 2,
    commentsList: [
      { user: 'kasperska.weronika', text: 'Cudowne dzieci 🤩 Piękne chwile ⛣️🤍' },
    ],
  },
  {
    id: 'post1',
    dateFull: '26 lipca 2026',
    caption: '🌿 Gontyniec zdobyty!🌿 W piątek 24.07 nasza młodzież zmierzyła się z różnymi zadaniami, wykazała się świetną współpracą i przy okazji doskonale się bawiła. Było aktywnie, z uśmiechem i w świetnej atmosferze – właśnie takie przygody lubimy najbardziej! 💙 ⚓️',
    image: '/images/1_1200x1200.webp',
    likes: 16,
    comments: 0,
  },
  {
    id: 'post3',
    dateFull: '18 lipca 2026',
    caption: '⛣️ Wiatr, woda i sportowe emocje – tak wyglądał nasz dzień 12 lipca w Wałczu! 🌊 Mieliśmy przyjemność wziąć udział w X Regatach o Złotą Szeklę Wałcza. To był dzień pełen żeglarskiej pasji, dobrej rywalizacji i niezapomnianych emocji. Cieszymy się, że mogliśmy być częścią tego wydarzenia. Do zobaczenia na kolejnych regatach! 🩵',
    image: '/images/2_1280x720.webp',
    likes: 20,
    comments: 1,
    commentsList: [
      { user: 'rafalczekiel', text: 'Super! 🔥' },
    ],
  },
  {
    id: 'post4',
    dateFull: '9 lipca 2026',
    caption: 'Wczorajszy trening z solidnym dodatkiem wiatru. 🌬️ Takie warunki też trzeba przerobić. 💪🏽 💨 🤙🏽',
    image: '/images/1_900x900.webp',
    likes: 24,
    comments: 2,
    commentsList: [
      { user: 'rafalczekiel', text: 'Trening czyni mistrza! Brawa dla młodych żeglarzy! 👏' },
    ],
  },

  {
    id: 'post5',
    dateFull: '4 lipca 2026',
    caption: 'Dzisiejszy trening odbył się z małymi przygodami 🤙🏽 było wymagająco i intensywnie, pomimo to wszyscy stanęli na wysokości zadania 💪🏽 🌊 💨',
    image: '/images/2_1200x1500.webp',
    likes: 22,
    comments: 1,
    commentsList: [
      { user: 'rafalczekiel', text: 'Pieknie wialo :D' },
    ],
  },
  {
    id: 'post6',
    dateFull: '21 czerwca 2026',
    caption: '🌺Chodzieskie Wianki 🌺 Na pięknie ozdobionych łódkach wypłynęliśmy na jezioro, by zgodnie z tradycją wypuścić wianki na wodę. Dziękujemy za wspólnie spędzony czas i pełen magii wieczór! ✨ ⛣️',
    image: clubImages.lake,
    likes: 23,
    comments: 0,
  },
  {
    id: 'post7',
    dateFull: '21 czerwca 2026',
    caption: '20–21.06.2026 uczestniczyliśmy w regatach IV Memoriał Bosmana Antoniego „Tolka” Łuczaka w Rogoźnie. ⛣️ Dwa dni żeglarskiej rywalizacji, sportowych emocji i świetnej atmosfery. Dziękujemy za wspólnie spędzony czas i do zobaczenia na kolejnych regatach!',
    image: '/images/2_900x900.webp',
    likes: 17,
    comments: 2,
    commentsList: [
      { user: 'rafalczekiel', text: '🔥' },
      { user: 'joanna.galko', text: 'Gratulacje dla wszystkich żeglarzy 🏆 💪 👍' },
    ],
  },

  {
    id: 'post8',
    dateFull: '31 maja 2026',
    caption: 'Za nami emocjonujące Regaty o Puchar Róży Wiatrów! Na starcie stanęli zawodnicy klas Europa, OKD oraz Omega, którzy przez cały weekend rywalizowali na wodzie, walcząc o jak najlepsze wyniki. Nie zabrakło sportowych emocji, zmiennych warunków wiatrowych i pięknej żeglarskiej atmosfery. Gratulujemy wszystkim uczestnikom zaangażowania, sportowej postawy oraz osiągniętych rezultatów. Dziękujemy za wspólnie spędzony czas. Do zobaczenia na kolejnych regatach! ⛣️ 🏆 🧭 💨',
    image: '/images/1_1280x720.webp',
    likes: 18,
    comments: 1,
    commentsList: [
      { user: 'rafalczekiel', text: 'Super! 🔥' },
    ],
  },
  {
    id: 'post9',
    dateFull: '31 maja 2026',
    caption: 'Nasi młodzi żeglarze z grupy szkoleniowej mieli wyjątkową okazję uczestniczyć w zajęciach organizowanych przez Fundację Feniks Chodzież z udziałem olimpijki @klaudia_adamek_. Po inspirującym spotkaniu Klaudia postanowiła sprawdzić się w zupełnie innej dyscyplinie sportowej niż lekkoatletyka i bobsleje – żeglarstwie! Było dużo uśmiechu, sportowych wyzwań i nowych doświadczeń. Dziękujemy za wspólnie spędzony czas i życzymy kolejnych sukcesów!!! ⛣️ 💙',
    image: '/images/2_1280x720.webp',
    likes: 28,
    comments: 0,
  },
  {
    id: 'post10',
    dateFull: '30 maja 2026',
    caption: '30.05.2026r. odbyło się uroczyste wręczenie podziękowań za wsparcie grupy szkoleniowej naszego klubu oraz za możliwość prowadzenia zajęć w okresie zimowego. Odbyło się również oficjalne przekazanie nowych kamizelek ratunkowych, które będą służyć naszym żeglarzom podczas treningów i rekreacyjnego pływania na żaglówkach. Bezpieczeństwo na wodzie jest dla nas priorytetem, dlatego cieszymy się, że nasze wyposażenie zostało wzbogacone o nowy sprzęt. Dziękujemy wszystkim osobom i instytucjom, które wspierają rozwój młodych żeglarzy i działalność naszego klubu. Razem dbamy o bezpieczne i komfortowe warunki do rozwijania żeglarskiej pasji! ⛣️ 🦺',
    image: '/images/2_1200x1500.webp',
    likes: 27,
    comments: 0,
  },
  {
    id: 'post11',
    dateFull: '28 maja 2026',
    caption: 'Wczorajszy trening klasy Europa i OKD 💨 ⛣️',
    image: '/images/1_1200x1500.webp',
    likes: 23,
    comments: 1,
    commentsList: [
      { user: 'rafalczekiel', text: 'Pieknie wialo :D' },
    ],
  },
];

export const regattas: Regatta[] = [
  {
    title: 'Piknik żeglarski',
    date: '7–9 sierpnia 2026',
    location: 'Jezioro Miejskie, Chodzież',
    description: '⛣️🌊 W dniach 7–9 sierpnia odbył się nasz piknik żeglarski! Trzy dni pełne żeglowania, wspólnej zabawy i świetnej atmosfery. Zaczęliśmy od treningu na żaglach i rozstawienia namiotów, a wieczorem obejrzeliśmy film „Wind”. Kolejny dzień przyniósł turniej badmintona, różne konkurencje i aktywności, a wieczorem wspólne śpiewanie szant przy ognisku. Ostatni dzień rozpoczęliśmy od wyprawy kajakami i SUP-ami na Łazinkach. Po powrocie i złożeniu biwaku czekała na nas prawdziwie żeglarska pogoda — dużo wiatru i słońca! Wspólnie z rodzicami i członkami klubu zeszliśmy na wodę, gdzie jednocześnie pływały łódki aż z siedmiu klas! Po powrocie na brzeg czekał na nas grill!',
    image: clubImages.hero,
    likes: 23,
    comments: 2,
  },
  {
    title: 'X Regaty o Złotą Szeklę Wałcza',
    date: '12 lipca 2026',
    location: 'Wałcz',
    description: '⛣️ Wiatr, woda i sportowe emocje – tak wyglądał nasz dzień 12 lipca w Wałczu! Mieliśmy przyjemność wziąć udział w X Regatach o Złotą Szeklę Wałcza. To był dzień pełen żeglarskiej pasji, dobrej rywalizacji i niezapomnianych emocji. Cieszymy się, że mogliśmy być częścią tego wydarzenia. Do zobaczenia na kolejnych regatach!',
    image: '/images/2_1280x720.webp',
    likes: 20,
    comments: 1,
  },
  {
    title: 'IV Memoriał Bosmana Antoniego „Tolka” Łuczaka',
    date: '20–21 czerwca 2026',
    location: 'Rogoźno',
    description: '20–21.06.2026 uczestniczyliśmy w regatach IV Memoriał Bosmana Antoniego „Tolka” Łuczaka w Rogoźnie. ⛣️ Dwa dni żeglarskiej rywalizacji, sportowych emocji i świetnej atmosfery. Dziękujemy za wspólnie spędzony czas i do zobaczenia na kolejnych regatach!',
    image: '/images/2_900x900.webp',
    likes: 17,
    comments: 2,
  },
  {
    title: 'Chodzieskie Wianki',
    date: '21 czerwca 2026',
    location: 'Jezioro Miejskie, Chodzież',
    description: '🌺 Chodzieskie Wianki 🌺 Na pięknie ozdobionych łódkach wypłynęliśmy na jezioro, by zgodnie z tradycją wypuścić wianki na wodę. Dziękujemy za wspólnie spędzony czas i pełen magii wieczór! ✨ ⛣️',
    image: clubImages.lake,
    likes: 23,
    comments: 0,
  },
  {
    title: 'Regaty o Puchar Róży Wiatrów',
    date: '31 maja 2026',
    location: 'Jezioro Miejskie, Chodzież',
    description: 'Za nami emocjonujące Regaty o Puchar Róży Wiatrów! Na starcie stanęli zawodnicy klas Europa, OKD oraz Omega, którzy przez cały weekend rywalizowali na wodzie, walcząc o jak najlepsze wyniki. Nie zabrakło sportowych emocji, zmiennych warunków wiatrowych i pięknej żeglarskiej atmosfery. Gratulujemy wszystkim uczestnikom zaangażowania, sportowej postawy oraz osiągniętych rezultatów. Do zobaczenia na kolejnych regatach! ⛣️ 🏆 🧭 💨',
    image: '/images/1_1280x720.webp',
    likes: 18,
    comments: 1,
  },
];

export const activities: Activity[] = [
  {
    title: 'Żeglarstwo na żaglach',
    description: 'Treningi na Jeziorze Miejskim w Chodzieży. Żeglarstwo rekreacyjne i regatowe na żaglówkach dla każdego poziomu zaawansowania.',
    icon: 'Sailboat',
  },
  {
    title: 'Regaty i rywalizacja',
    description: 'Uczestniczymy w regatach i zawodach żeglarskich w regionie. Rywalizujemy z innymi klasami, dbając o fair play i sportową atmosferę.',
    icon: 'Trophy',
  },
  {
    title: 'Młodzież i dzieci',
    description: 'Nasza młodzież zmierza się z różnymi zadaniami — od treningów po wyjątkowe przygody na wodzie.',
    icon: 'Users',
  },
];

export const galleryImages: GalleryItem[] = [
  { src: clubImages.hero, alt: 'Piknik żeglarski', caption: 'Piknik żeglarski • 7–9 sierpnia 2026' },
  {
    src: '/images/1_1200x1200.webp',
    alt: 'Gontyniec zdobyty', caption: 'Gontyniec zdobyty! • 24.07',
  },
  {
    src: '/images/2_1200x1200.webp',
    alt: 'Trening na żaglach', caption: 'Trening • 18.07',
  },
  {
    src: '/images/1_900x900.webp',
    alt: 'Trening z wiatrem', caption: 'Trening z wiatrem • 9.07',
  },
  { src: clubImages.lake, alt: 'Chodzieskie Wianki', caption: 'Chodzieskie Wianki • 21.06' },
  {
    src: '/images/2_900x900.webp',
    alt: 'IV Memoriał Bosmana Antoniego „Tolka” Łuczaka', caption: 'IV Memoriał w Rogoźnie • 20–21.06',
  },
  {
    src: '/images/1_1280x720.webp',
    alt: 'Regaty o Puchar Róży Wiatrów', caption: 'Puchar Róży Wiatrów • 31.05',
  },
  {
    src: '/images/2_1280x720.webp',
    alt: 'Sesja z olimpijką Klaudią Adamek', caption: 'Sesja z @klaudia_adamek_ • 31.05',
  },
  {
    src: '/images/1_1200x1500.webp',
    alt: 'Trening klasy Europa i OKD', caption: 'Trening klasy Europa i OKD • 28.05',
  },
  {
    src: '/images/2_1200x1500.webp',
    alt: 'Kamizelki ratunkowe', caption: 'Nowe kamizelki ratunkowe • 30.05',
  },
];
